import { render, staticRenderFns } from "./DetalhesContato.vue?vue&type=template&id=d7444f08&scoped=true&"
import script from "./DetalhesContato.vue?vue&type=script&lang=js&"
export * from "./DetalhesContato.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesContato.vue?vue&type=style&index=0&id=d7444f08&scoped=true&lang=css&"
import style1 from "./DetalhesContato.vue?vue&type=style&index=1&id=d7444f08&scoped=true&lang=css&"
import style2 from "./DetalhesContato.vue?vue&type=style&index=2&id=d7444f08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7444f08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VContainer,VDialog,VFlex,VIcon,VLayout,VProgressCircular,VSnackbar,VSpacer,VSubheader,VSwitch})
